import { useState } from 'react';

const cards = [
  {
    id: 1,
    title: '我独自升级',
    tag: '韩漫 · 热血',
    desc: '史上最弱猎人觉醒系统，逆天改命踏上最强之路。',
    status: '连载中 · 178话',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20lone%20warrior%20with%20glowing%20blue%20energy%20surrounded%20by%20shadows%2C%20dark%20atmospheric%20background%20with%20dramatic%20lighting%2C%20manga%20cover%20composition%20on%20clean%20minimal%20background%2C%20Korean%20webtoon%20aesthetic%2C%20no%20text%20on%20image&width=600&height=800&seq=card-01&orientation=portrait',
  },
  {
    id: 2,
    title: '咒术回战',
    tag: '日漫 · 战斗',
    desc: '高中生踏入咒术世界，与诅咒展开殊死搏斗。',
    status: '连载中 · 271话',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20dynamic%20battle%20scene%20with%20dark%20energy%20swirling%20around%20a%20figure%20in%20school%20uniform%2C%20supernatural%20elements%20and%20cursed%20energy%20effects%2C%20clean%20minimal%20background%2C%20Japanese%20shonen%20manga%20aesthetic%2C%20no%20text%20on%20image&width=600&height=800&seq=card-02&orientation=portrait',
  },
  {
    id: 3,
    title: '某天成为公主',
    tag: '韩漫 · 恋爱',
    desc: '穿越成小说里悲惨公主，用智慧改写命运。',
    status: '连载中 · 125话',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20an%20elegant%20princess%20in%20a%20beautiful%20gown%20with%20flowers%20and%20soft%20pastel%20colors%2C%20romantic%20fantasy%20atmosphere%2C%20clean%20minimal%20background%2C%20Korean%20webtoon%20romance%20aesthetic%2C%20no%20text%20on%20image&width=600&height=800&seq=card-03&orientation=portrait',
  },
  {
    id: 4,
    title: '鬼灭之刃',
    tag: '日漫 · 冒险',
    desc: '少年为救妹妹踏上斩鬼之旅，感动千万读者。',
    status: '已完结 · 205话',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20young%20swordsman%20with%20water%20breathing%20effects%20and%20traditional%20Japanese%20patterns%2C%20dramatic%20composition%20with%20flowing%20movement%2C%20clean%20minimal%20background%2C%20Japanese%20manga%20aesthetic%2C%20no%20text%20on%20image&width=600&height=800&seq=card-04&orientation=portrait',
  },
  {
    id: 5,
    title: '全知读者视角',
    tag: '韩漫 · 奇幻',
    desc: '唯一读完末日小说的人，世界真的迎来了末日。',
    status: '连载中 · 210话',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20an%20apocalyptic%20fantasy%20scene%20with%20a%20figure%20holding%20a%20glowing%20book%2C%20dramatic%20dark%20and%20gold%20color%20scheme%2C%20clean%20minimal%20background%2C%20Korean%20webtoon%20fantasy%20aesthetic%2C%20no%20text%20on%20image&width=600&height=800&seq=card-05&orientation=portrait',
  },
  {
    id: 6,
    title: '间谍过家家',
    tag: '日漫 · 喜剧',
    desc: '间谍、杀手、超能力少女组成伪家庭，笑中带泪。',
    status: '连载中 · 98话',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20whimsical%20family%20scene%20with%20three%20figures%20in%20stylish%20outfits%2C%20playful%20and%20warm%20atmosphere%2C%20clean%20minimal%20background%2C%20Japanese%20comedy%20manga%20aesthetic%2C%20no%20text%20on%20image&width=600&height=800&seq=card-06&orientation=portrait',
  },
  {
    id: 7,
    title: '剑尊归来',
    tag: '韩漫 · 武侠',
    desc: '天下第一剑重生归来，横扫武林再登巅峰。',
    status: '连载中 · 142话',
    img: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20style%20illustration%20of%20a%20martial%20arts%20master%20with%20a%20sword%20and%20flowing%20robes%2C%20dramatic%20wind%20effects%20and%20traditional%20Eastern%20aesthetic%2C%20clean%20minimal%20background%2C%20Korean%20webtoon%20martial%20arts%20aesthetic%2C%20no%20text%20on%20image&width=600&height=800&seq=card-07&orientation=portrait',
  },
];

export default function CardsSection() {
  const [activeTag, setActiveTag] = useState('全部');

  const tags = ['全部', '韩漫', '日漫', '热血', '恋爱', '奇幻', '武侠'];

  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门推荐</h2>
            <p className="mt-2 text-sm text-foreground-500">每日精选好漫，追更不迷路</p>
          </div>
          <div className="flex flex-wrap items-center gap-1.5 bg-background-100 rounded-full p-1">
            {tags.map((tag) => (
              <button
                key={tag}
                onClick={() => setActiveTag(tag)}
                className={`px-4 py-1.5 text-xs font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                  activeTag === tag
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {cards.map((card) => (
            <a key={card.id} href="#cards" className="group block cursor-pointer">
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-100">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-xl"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <span className="inline-block px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {card.status}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">{card.title}</h3>
              <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">{card.tag}</p>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a href="#index" className="inline-flex items-center gap-2 px-6 py-2.5 border border-foreground-200 text-foreground-600 text-sm font-medium rounded-full hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
            查看更多热门漫画 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}